import React from 'react';

import { Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

const HEADING_SKELETON_WIDTH = '128px';
const HEADING_SKELETON_HEIGHT = '16px';
const ROW_SKELETON_HEIGHT = '50px';

const SectionSkeleton = () => (
	<Stack space="space.100" testId="update-status-action-skeleton-section">
		<Skeleton
			width={HEADING_SKELETON_WIDTH}
			height={HEADING_SKELETON_HEIGHT}
			borderRadius={token('radius.small')}
			isShimmering
		/>
		<Skeleton
			width="100%"
			height={ROW_SKELETON_HEIGHT}
			borderRadius={token('radius.small')}
			isShimmering
		/>
	</Stack>
);

export const UpdateStatusActionSkeleton = ({
	hasStatusName,
	hasStatusCategory,
}: {
	hasStatusName: boolean;
	hasStatusCategory: boolean;
}): React.JSX.Element => (
	<Stack space="space.100" testId="update-status-action-skeleton">
		{hasStatusName && <SectionSkeleton />}
		{hasStatusCategory && <SectionSkeleton />}
	</Stack>
);
